import React, { useEffect } from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { UiKit } from 'components';
import Header from './Header';
import LabelTypes from './LabelTypes';
import CarrierServices from './CarrierServices';
import { useForm, useMutation } from 'utils/hooks';
import { FORM_SCHEMA, DEFAULT_FORM_DATA } from './stubs';
import { createInitialData, createPayload } from './methods';

export default function CarrierConfig({
  carrier = null,
  isOpen = false,
  onClose = () => {},
  onClosed = () => {},
  onRefresh = () => {}
}) {
  const { data, errors, onChange, onValidate, onSetInitialData } = useForm({
    defaultData: DEFAULT_FORM_DATA,
    dataSchema: FORM_SCHEMA
  });

  const id = _get(carrier, 'id', '');
  const name = _get(carrier, 'name', '');
  const slas = _get(carrier, 'slas', '');
  const isByoc = _get(carrier, 'is_byoc', false);
  const carrierId = _get(carrier, 'carrier_id', '');
  const supportedLabelTypes = _get(carrier, 'supported_label_types', []);

  useEffect(() => {
    if (isOpen && carrier) {
      onSetInitialData(createInitialData(carrier));
    }
  }, [isOpen, carrier, onSetInitialData]);

  const { mutate, isProcessing } = useMutation(
    'configure.aggregator.sla_update',
    'PUT',
    {
      routeParam: id,
      successMessage: `Successfully updated the carrier ${name}.`,
      errorMessage: err => {
        const msg = _get(err, 'displayMessage.message', '');
        return (
          msg ||
          'Unable to update the slas for the carrier at the moment. Please try again later.'
        );
      },
      payload: () => createPayload(data, carrier),
      onValidate: () => onValidate(data),
      onSuccess: () => {
        onClose();
        onRefresh();
      },
      onError: err => onRefresh(err)
    }
  );

  if (!carrier) return null;

  return (
    <UiKit.SideSheet
      size="md"
      isOpen={isOpen}
      title="Carrier Configuration"
      onClose={onClose}
      onClosed={onClosed}
      onConfirm={() => mutate()}
      isProcessing={isProcessing}
      isConfirmDisabled={!_isEmpty(errors)}
    >
      <UiKit.Grid templateColumns="1fr" gap="24">
        <Header name={name} isByoc={isByoc} carrierId={carrierId} />
        <LabelTypes
          types={supportedLabelTypes}
          data={data}
          onChange={onChange}
          isDisabled={isProcessing}
        />
        <CarrierServices
          slas={slas}
          data={data}
          errors={errors}
          onChange={onChange}
          isDisabled={isProcessing}
        />
      </UiKit.Grid>
    </UiKit.SideSheet>
  );
}
